import { Spinner } from '@chakra-ui/react';

import ErrorPage from '~/pages/error/ErrorPage';
import { useGetPlaylistByIdQuery } from '~/services/api/playlist.service';

import PlaylistContent from './PlaylistContent';

type Props = {
  playlistId: string;
};

function PlaylistContentContainer({ playlistId }: Props) {
  const { data, isLoading, isError } = useGetPlaylistByIdQuery(playlistId);

  if (isLoading) {
    return <Spinner size='md' />;
  }

  if (isError || !data) {
    return <ErrorPage />;
  }

  return <PlaylistContent playlist={data} />;
}

export default PlaylistContentContainer;
